<div class="map-dialog">
  <div class="map-dialog-header">
    <div class="map-dialog-title">
      <div class="location-icon">
        <mat-icon>share_location</mat-icon>
      </div>

      <h2>Seleccionar ubicación</h2>
    </div>

    <span>
      Busca una dirección y confirma su ubicación en el mapa
    </span>
  </div>

  <div class="map-container">
    <app-new-map #mapComponent [zoom]="zoom" [lat]="lat" [lng]="lng"></app-new-map>

    <div class="map-search">
      <app-map-position [address]="data?.address" (notify)="handleInputChange($event)"></app-map-position>
    </div>
  </div>

  <div class="map-dialog-actions">
    <button mat-stroked-button class="button-success" type="button" (click)="accept()" [disabled]="!locationSelected">
      Aceptar
    </button>
  </div>
</div>

<button mat-button mat-dialog-close class="dialog-close">
  <mat-icon class="here-map-close">close</mat-icon>
</button>